import { z } from "zod";
import { JoinPathSchema } from "./JoinPath";

const JoinSchema = z.object({
  table: z.string().min(1),
  path: z.array(JoinPathSchema).min(1),
});

const ColumnSchema = z.object({
  label: z.string().min(1),
  column: z.string().min(1),
  table: z.string().optional(),
});

export const UpdateExportDefinitionRequestSchema = z.object({
  name: z.string().max(255).optional(),
  columns: z.array(ColumnSchema).min(1).optional(),
  joins: z.array(JoinSchema).optional(),
});

export type UpdateExportDefinitionRequest = z.infer<typeof UpdateExportDefinitionRequestSchema>;